import { USER_ROLES } from '@bagonboard/wiseman';
import { isEmpty } from 'ramda';
import Yup from '#yup';

const CREATE_LAF_USERS_ROLES = [
  USER_ROLES.HANDLING_COMPANY_AGENT,
  USER_ROLES.HANDLING_COMPANY_OPERATOR,
];
const COURIER_USERS = [
  USER_ROLES.AGENT,
  USER_ROLES.COURIER_AGENT,
];
const ADMIN_OUTSIDERS = [
  USER_ROLES.COURIER_ADMIN,
  USER_ROLES.HANDLING_COMPANY_MANAGER,
];
const COMPANY_USERS = [
  ...ADMIN_OUTSIDERS,
  ...COURIER_USERS,
  ...CREATE_LAF_USERS_ROLES,
];
const ADMINS = [
  USER_ROLES.ADMIN,
  USER_ROLES.SUPER_ADMIN,
];
const REGEX = {
  lowercase: /^.*[ña-z]+.*$/,
  uppercase: /^.*[ÑA-Z]+.*$/,
  special  : /^.*[\d!@#$%^&*\\.\\,_-]+.*$/,
};
const isAdminLogged = role => ADMINS.includes(role);
const isLAFUser = role => CREATE_LAF_USERS_ROLES.includes(role);
const isCourierUser = role => COURIER_USERS.includes(role);
const isRoleWithCompanyMandatory = (role, id) => !id && COMPANY_USERS.includes(role);

export const validationSchema = Yup.object().shape({
  id      : Yup.string().trim(),
  name    : Yup.string().trim().required(),
  surname : Yup.string().trim(),
  phone   : Yup.string().trim(),
  email   : Yup.string().email('Invalid email').required(),
  language: Yup.string(), // .required('No language selected'),
  role    : Yup.string().trim().required(),
  company : Yup.string().trim(),
  areas   : Yup.array(Yup.string())
    .when('role', {
      is  : isCourierUser,
      then: schema => schema.required().min(1),
    }),
  poi: Yup.string().trim()
    .when('role', {
      is  : isLAFUser,
      then: schema => schema.required(),
    }),
  terminal: Yup.string().trim()
    .when('role', {
      is  : isLAFUser,
      then: schema => schema.required(),
    }),
  password: Yup.string().trim()
    .min(8)
    .max(99)
    .matches(REGEX.lowercase, 'lowercase')
    .matches(REGEX.uppercase, 'uppercase')
    .matches(REGEX.special, 'special chars allowed')
    .when('id', {
      is  : val => !val,
      then: schema => schema.required(),
    }),
});

export const validateCompany = loggedRole => (values) => {
  const errors = {};
  if (
    isAdminLogged(loggedRole)
    && isRoleWithCompanyMandatory(values.role)
    && isEmpty(values.company)
  ) {
    errors.company = 'Required';
  }
  return errors;
};
